import { type RouteRecordRaw } from "vue-router";

import { APP_ROUTES } from "@/Generated/Routes/paths";

export const loginRoute: RouteRecordRaw = {
  ...APP_ROUTES.login.root,
  meta: { isPublic: true, canonical: APP_ROUTES.login.root.path },
  component: () => import("@/Views/login/Login.vue"),
};

export const recoverPasswordRoute: RouteRecordRaw = {
  ...APP_ROUTES.recoverPassword.root,
  meta: { isPublic: true },
  component: () => import("@/Views/recover-password/RecoverPassword.vue"),
};

export const resetPasswordRoute: RouteRecordRaw = {
  ...APP_ROUTES.resetPassword.root,
  meta: { isPublic: true },
  component: () => import("@/Views/reset-password/ResetPassword.vue"),
};

export const loginCodeRoute: RouteRecordRaw = {
  ...APP_ROUTES.code.root,
  meta: { isPublic: true },
  component: () => import("@/Views/2-factor/Index.vue"),
};

export default [loginRoute, recoverPasswordRoute, resetPasswordRoute, loginCodeRoute];
